import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const FontItalicIcon = React.memo(function FontItalicIcon(props: TFontItalicIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Italic" {...props}>
            <path d="M8 4.4C8 4.17909 8.17909 4 8.4 4H11.7054H12.3907H15.725C15.9459 4 16.125 4.17909 16.125 4.4V5.16C16.125 5.38091 15.9459 5.56 15.725 5.56H12.575L10.6635 15.5H13.6C13.8209 15.5 14 15.6791 14 15.9V16.66C14 16.8809 13.8209 17.06 13.6 17.06H6.275C6.05409 17.06 5.875 16.8809 5.875 16.66V15.9C5.875 15.6791 6.05409 15.5 6.275 15.5H9.16346L11.075 5.56H8.4C8.17909 5.56 8 5.38091 8 5.16V4.4Z" />
        </IconBase>
    );
});

export default FontItalicIcon;

// #region Types

export type TFontItalicIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <FontItalicIcon /> : { ...IconBaseExample, render: FontItalicIcon };

// #endregion
